import moment from "moment-timezone";
import Constants from "./Constants";

const parseAsLocalDate = (dateString) => {
    const dateOnlyMatch = String(dateString).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnlyMatch) {
        return new Date(
            Number(dateOnlyMatch[1]),
            Number(dateOnlyMatch[2]) - 1,
            Number(dateOnlyMatch[3])
        );
    }

    const parsedDate = new Date(dateString);
    if (isNaN(parsedDate.getTime())) {
        return null;
    }

    return parsedDate;
};

const isDateWithinDaysFromToday = (dateString, dayLimit, now = new Date()) => {
    if (!dateString || dayLimit == null) {
        return false;
    }

    const parsedLimit = Number(dayLimit);
    const targetDate = parseAsLocalDate(dateString);
    const todayDate = new Date(now);

    if (!Number.isFinite(parsedLimit) || parsedLimit < 0 || !targetDate || isNaN(todayDate.getTime())) {
        return false;
    }

    todayDate.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const dayDifference = Math.floor(
        (targetDate.getTime() - todayDate.getTime()) / (24 * 60 * 60 * 1000)
    );

    return dayDifference >= 0 && dayDifference <= parsedLimit;
};

const compareDateTimewithSystem = (downtime) => {
    // The time is considered in ET
    if (!downtime || !downtime.startTime || !downtime.endTime) {
        return false; // Return false if downtime data is not available
    }

    const acceptedFormats = ["MM/DD/YYYY hh:mm A"];
    const now = moment.tz(Constants.TIME_ZONE_EST);
    const start = moment.tz(downtime.startTime, acceptedFormats, Constants.TIME_ZONE_EST);
    const end = moment.tz(downtime.endTime, acceptedFormats, Constants.TIME_ZONE_EST);

    if (!start.isValid() || !end.isValid()) {
        return false;
    }

    return now.isBetween(start, end, undefined, "[]");
};

export { isDateWithinDaysFromToday, compareDateTimewithSystem };
